import React from "react";
import { useContext } from 'react';
import UploadButton from "../UploadButton/UploadButton.component";
import { NavigationButton, SelectedNavButton } from "../Button/Button.styles";
import { NavContext } from "../../contexts/navigation.context";
import { FunctionContext } from "../../contexts/function.context";

const UploadGroup = (props) => {

    const { currentNavigationPath, setNavigationPath } = useContext(NavContext);
    const { currentFunctionCode, setFunctionCode } = useContext(FunctionContext);

    React.useEffect(() => {
        if(process.env.REACT_APP_LOGGING_LEVEL !== '0') {
            console.log('rendering UploadGroup');
            console.log(props.buttonList)
            console.log(props.groupTitle)
            console.log(props.groupCode)
            console.log(props.envCode)
            console.log(currentFunctionCode)
        }
    });

    const selectNavigationGroup = (navigationGroup) => {
        setNavigationPath(navigationGroup);
        setFunctionCode({
            code: '',
            path: '',
            name: '',
            type: '',
            url: '',
        });
    };

    return (
        <div>
            {
                props.groupCode === currentNavigationPath ? (
                    <SelectedNavButton key={`${props.groupCode}`} onClick={() => {selectNavigationGroup(null)}} >{ props.groupTitle }</SelectedNavButton>

                ) : (
                    <NavigationButton key={`${props.groupCode}`} onClick={() => {selectNavigationGroup(props.groupCode)}} >{ props.groupTitle }</NavigationButton>
                )
            }
            
            {
                props.groupCode === currentNavigationPath ? (
                    props.buttonList.map((uploadItem) => {
                        return <UploadButton key={uploadItem.name} buttonText={`${uploadItem.name}`} hoverText={`${uploadItem.code}`} buttonItem={uploadItem} envCode={props.envCode} />
                    })
                ) : (null)
            }
       </div>
    ) 
}

export default UploadGroup;